import React from 'react';

import { Typography } from '@material-ui/core';

function Question({ children }) {
  return (
    <Typography
      variant="body1"
      style={{
        padding: 10,
        marginTop: '15px',
      }}
    >
      {children}
    </Typography>
  );
}

export default Question;
